import { keys, pick } from 'es-toolkit/compat';
import { stringify } from 'qs';
import { encodeQueryParams, QueryParamConfig } from 'use-query-params';

export const encodeQueryParamsUsingSchema = (
  params: { [key: string]: any },
  schema: Record<string, QueryParamConfig<any, any>>,
  options: Record<string, string> = {}
) => {
  return stringify(encodeQueryParams(pick(schema, keys(params)), params), options);
};
